import { render } from "./InteractiveInfo.vue?vue&type=template&id=28afe8af&scoped=true"
import script from "./InteractiveInfo.vue?vue&type=script&lang=js"
export * from "./InteractiveInfo.vue?vue&type=script&lang=js"

import "./InteractiveInfo.vue?vue&type=style&index=0&id=28afe8af&scoped=true&lang=scss"
import "./InteractiveInfo.vue?vue&type=style&index=1&id=28afe8af&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28afe8af"]])

export default __exports__